import type { Auth } from '~~/shared-components/types/Auth'

export function useAuth() {
  return useState<Auth>('auth')
}
